var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"beam",style:({ paddingLeft: _vm.padLeft }),attrs:{"id":"base-beam"}},[_c('div',{staticClass:"after"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }